import api from "@/api/api-v2-config";

export async function getEmployeeTrainingListAxios(id) {    
    if (id) {
        return await api.get(`hrms/employeetrainings?EmployeeId=${id}`);
      } else {
        return await api.get("hrms/employeetrainings?PageNumber=1&PageSize=1000");
      }
}

export async function deleteEmployeeTrainingAxios(id) {    
    return await api.delete("hrms/employeetraining?EmployeeTrainingId=" + id);
}

export async function postEmployeeTrainingAxios(employeeTraining) {    
    return await api.post("hrms/employeetraining", employeeTraining);
}

export async function putEmployeeTrainingAxios(employeeTraining) {    
    return await api.put("hrms/employeetraining", employeeTraining);
}

export async function getEmployeeTrainingByIDAxios(id) {    
    return await  api.get(`/hrms/employeetraining?EmployeeTrainingId=${id}`);
}